import { ComponentStyleProps } from "../../../../lib/styles/props/component-style-props";
import {
  Button,
  ComponentMultiStyleConfig,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  useDisclosure,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import { CMSearchResultCellFrame } from "../CMSearchResultCellFrame/CMSearchResultCellFrame";
import { hasValue } from "../../../../lib/util/common-util";
import { CMSearchResultCellJsonDiffModal } from "./_components/CMSearchResultCellJsonDiffModal/CMSearchResultCellJsonDiffModal";

export type CMSearchResultCellJsonDiffProps = {
  value?: {
    before: any;
    after: any;
  };

  options?: {
    contentText?: string;
    beforeLabel?: string;
    afterLabel?: string;
    closeButtonLabel?: string;
    jsonIndent?: number;
  };
} & ComponentStyleProps;

export const CMSearchResultCellJsonDiff = ({
  value,
  options,

  sx,
  ...rest
}: CMSearchResultCellJsonDiffProps) => {
  const styles = useMultiStyleConfig("CMSearchResultCellJsonDiffStyles");

  const containerStyles = useMemo(
    () => ({ ...styles.container, ...sx }),
    [styles.container, sx],
  );

  const { onOpen, onClose, isOpen } = useDisclosure();

  return (
    <>
      <CMSearchResultCellFrame sx={containerStyles} {...rest}>
        {hasValue(value) && (
          <Button variant={"link"} sx={styles.content} onClick={onOpen}>
            <Text>{options?.contentText ?? "Show"}</Text>
          </Button>
        )}
      </CMSearchResultCellFrame>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent sx={styles.modalContent}>
          <ModalBody sx={styles.modalBody}>
            <CMSearchResultCellJsonDiffModal
              value={value}
              options={options}
              onClose={onClose}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export const CMSearchResultCellJsonDiffStyles: ComponentMultiStyleConfig = {
  parts: ["container", "content", "modalContent", "modalBody"],
  baseStyle: {
    container: {},
    content: {
      whiteSpace: "pre-wrap",
      overflowWrap: "anywhere",
      fontSize: "sm",
      fontWeight: "normal",
      color: "blue.500",
    },
    modalContent: {
      p: 0,
      minW: "500px",
      maxW: "860px",
      overflow: "hidden",
    },
    modalBody: {
      p: 0,
    },
  },
};
